<template>
    <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
            <p class="modal-card-title" style="margin: 0px;">New Issue</p>
        </header>
        <section class="modal-card-body change-password-modal">
            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Priority">                     
                        <ul class="priority-list">
                           <li>
                               <b-radio-button v-model="task.priority"
                                    :native-value="2"
                                    type="is-danger" class="text-center">
                                    High
                                </b-radio-button>
                            </li>
                            <li>
                               <b-radio-button v-model="task.priority"
                                    :native-value="1"
                                    type="is-warning" class="text-center">
                                    Medium
                                </b-radio-button>
                            </li>
                            <li>
                               <b-radio-button v-model="task.priority"
                                    :native-value="0"
                                    type="is-low" class="text-center">
                                    Low
                                </b-radio-button>
                            </li>
                       </ul>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Workspace">                     
                        <b-select v-model="task.workspace_id">
                            <template v-for="workspace in workspaces">
                                <option :value="workspace.id" :key="workspace.id">
                                    {{workspace.name}}
                                </option>
                            </template>
                        </b-select>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Name">                     
                        <b-input type="text" v-model="task.name" maxlength="50" required></b-input>
                    </b-field>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <b-field label="Description">                     
                        <WYSIWYG v-model="task.content" />
                    </b-field>
                </div>
            </div>

        </section>
        <footer class="modal-card-foot" style="text-align: right;">
            <button class="button" type="button" @click="$parent.close()">Close</button>
            <button class="button is-primary" @click="emitEvent">Create issue</button>
        </footer>
    </div>
</template>

<script>
import WYSIWYG from "../components/WYSIWYG";


let password = "";
let password_confirm = "";
let error = false;
let errorPattern = false;

let task = {
    "priority": "0",
    "name": "",
    "content": "",
    "files": [],
    "workspace_id": null,
}

export default {
    name: 'ModalCreateTask',
    props: {
        workspaces: Array,
        current_workspace: String || null
    },
    data(){
        return {
            password: password,
            password_confirm: password_confirm,
            error: error,
            errorPattern: errorPattern,
            task: task
        }
    },
    components: {WYSIWYG},
    methods:{
        emitEvent: function(){
            this.$emit('task_created', this.task);
            this.$parent.close();
            this.task = {
                "priority": "0",
                "name": "",
                "content": "",
                "files": [],
            }
        },
    },
    mounted: function () {
        console.log(this.workspaces)
        console.log(this.current_workspace)
        this.task["workspace_id"] = this.current_workspace
    }
}
</script>

<style scoped>
    .priority-list li{
        display: inline-block;
        margin-left: -1px;
    }
    .priority-list li >>> .button{
        border-radius: 0px;
        font-size: 14px;
    }
    .priority-list li >>> label{
        font-weight: 400;
        margin: 0px;
    }
    .change-password-modal >>> .input{
        max-width: 100%;
        width: 350px;
    }
    .change-password-modal >>> .label{
        font-weight: 400;
        text-align: left;
        padding-left: 0px;
    }
    .change-password-modal >>> .field{
        margin-bottom: 20px;
    }
</style>
